export default __webpack_public_path__ + "static/media/cStyleExamining.fdad531b.png";